import React from 'react';

export default function Pagination({ total = 0, perPage = 10, current = 1, onChange }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  if (totalPages <= 1) return null;

  // show up to 7 pages around currently selected
  const windowSize = 7;
  let start = Math.max(1, current - Math.floor(windowSize/2));
  let end = Math.min(totalPages, start + windowSize - 1);
  start = Math.max(1, end - windowSize + 1);

  const pages = [];
  for (let p = start; p <= end; p++) pages.push(p);

  return (
    <div className="flex gap-1 my-4 text-sm">
      <button className="block px-4 py-2 rounded shadow hover--text-white hover--bg-ubc-blue" onClick={() => onChange(Math.max(1, current - 1))} disabled={current === 1}>
        Prev
      </button>

      {start > 1 && (
        <>
          <button className="block px-4 py-2 rounded shadow hover--text-white hover--bg-ubc-blue" onClick={() => onChange(1)}>1</button>
          {start > 2 && <span>…</span>}
        </>
      )}

      {pages.map(p => (
        <button
          className="block px-4 py-2 rounded shadow hover--text-white hover--bg-ubc-blue"
          key={p}
          onClick={() => onChange(p)}
          aria-current={current === p ? 'page' : undefined}
          style={{
            background: current === p ? '#002145' : undefined,
            color: current === p ? '#fff' : undefined,
          }}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="block px-2 py-2"> … </span>}
          <button className="block px-4 py-2 rounded shadow hover--text-white hover--bg-ubc-blue" onClick={() => onChange(totalPages)}>{totalPages}</button>
        </>
      )}

      <button className="block px-4 py-2 rounded shadow hover--text-white hover--bg-ubc-blue" onClick={() => onChange(Math.min(totalPages, current + 1))} disabled={current === totalPages}>
        Next
      </button>
    </div>
  );
}
